import React, {PureComponent} from 'react';

class Rule extends PureComponent {
  render() {
    const { style } = this.props;

    return (<div style={style} >{this.props.children}</div>);
  }
}




export default Rule;